import { Archive } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const InventoryIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Archive width={size} height={size} color={color} {...rest} />;

InventoryIcon.displayName = 'InventoryIcon';

export default InventoryIcon;
